/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Benefit_Guarantees_TitleInputs */

const en_business_benefit_guarantees_title = /** @type {(inputs: Business_Benefit_Guarantees_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Guarantees`)
};

const es_business_benefit_guarantees_title = /** @type {(inputs: Business_Benefit_Guarantees_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garantías de servicio`)
};

/**
* | output |
* | --- |
* | "Service Guarantees" |
*
* @param {Business_Benefit_Guarantees_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_benefit_guarantees_title = /** @type {((inputs?: Business_Benefit_Guarantees_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Benefit_Guarantees_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_benefit_guarantees_title(inputs)
	return en_business_benefit_guarantees_title(inputs)
});